import { InputLabel, ListItemText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React from 'react';
import { useTranslation } from 'react-i18next';

const InventoryPolicySelect = ({ required = false, value, onChange, error, helperText, ...selectProps }) => {
  const { t } = useTranslation();

  const inventoryPolicies = [
    {
      value: 'none',
      label: t('billing.none', 'None'),
      description: t('billing.inventoryPolicyNoneDesc', 'No inventory will be billed.'),
    },
    {
      value: 'exact',
      label: t('billing.exact', 'Exact'),
      description: t('billing.inventoryPolicyExactDesc', 'Exact inventory count is billed.'),
    },
    {
      value: 'fixed',
      label: t('billing.fixed', 'Fixed'),
      description: t('billing.inventoryPolicyFixedDesc', 'A fixed amount of inventory is billed per site group/plant.'),
    },
    {
      value: 'percentage',
      label: t('billing.percentage', 'Percentage'),
      description: t(
        'billing.inventoryPolicyPercentageDesc',
        'Billing is based on a percentage of site group/plant inventory.',
      ),
    },
  ];

  const handleChange = event => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl required={required} error={error} size="small">
      <InputLabel>{t('billing.inventoryPolicy', 'Inventory Policy')}</InputLabel>
      <Select
        size="small"
        required={required}
        label={t('billing.inventoryPolicy', 'Inventory Policy')}
        value={value ?? 'none'}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': t('billing.selectInventoryPolicy', 'Select Inventory Policy') }}
        sx={{ minWidth: '200px' }}
        {...selectProps}
      >
        <MenuItem value="" disabled>
          <ListItemText primary={t('billing.selectInventoryPolicy', 'Select Inventory Policy')} />
        </MenuItem>
        {inventoryPolicies.map(policy => (
          <MenuItem key={policy.value} value={policy.value}>
            <ListItemText primary={policy.label} secondary={policy.description} />
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default InventoryPolicySelect;
